export default class GeneWedge {

  constructor(name, {label, shortLabel}, {start, end,  aa, saa, eaa}, drawCallback) {
    this.name = name;
    this.label = label;
    this.shortLabel = shortLabel;
    this.startNuc = start;
    this.endNuc = end;
    this.aaCount = aa;
    this.startAA = saa;
    this.endAA = eaa;
    this.visibles = [];
    this.shown = true;
    this.drawCallback = drawCallback;
  }

  setShown(isShown=true) {
    this.shown = isShown;
    this.drawCallback();
  }


  setAngles(sa, ea) {
    this.sa = sa;
    this.ea = ea;
    this.angleRange = ea - sa;
    this.cs = Math.cos(sa);
    this.ss = Math.sin(sa);
    this.ce = Math.cos(ea);
    this.se = Math.sin(ea);
  }

  setXpositions(left, width) {
    this.x1 = left;
    this.width = width;
    this.x2 = left + width;
    this.xtarget = left;
    this.widthtarget = width;
    this.xHome = left;
    this.widthHome = width;
  }

  adjustX(xAmount = 0) {
    this.xtarget = this.xHome + xAmount;
  }

  adjustW(wAmount=0) {
    this.widthtarget = this.widthHome + wAmount;
  }

  update() {
    let updating = false;
    if (this.xtarget !== this.x1) {
      this.x1 += (this.xtarget - this.x1) * 0.5;
      if (Math.abs(this.xtarget - this.x1) > 0.01) {
        updating = true;
      }
    }
    if (this.widthtarget !== this.width) {
      this.width += (this.widthtarget - this.width) * 0.5;
      if (Math.abs(this.widthtarget - this.width) > 0.01) {
        updating = true;
      }
    }
    return updating;
  }

  getX(mutation) {
    return mutation.position / (this.aaCount - 1) * this.width + this.xHome;
  }

  getAngle(mutation) {
    return mutation.position / this.aaCount * this.angleRange + this.sa;
  }

  resetVisibles() {
    this.visibles.length = [];
  }

  addMutationItem(item) {
    this.visibles.push(item);
    item.angle = this.getAngle(item.mutation);
    item.cosA = Math.cos(item.angle);
    item.sinA = Math.sin(item.angle);
  }

}